// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3wc6UTOZlnzJ6E1MmFcQ50{overflow:hidden;border-radius:.7rem;height:.3rem}._3wc6UTOZlnzJ6E1MmFcQ50._1TfpOMz5_FtHBhNy7iRnPk{border-radius:.6rem;width:.3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_3wc6UTOZlnzJ6E1MmFcQ50",
	"vertical": "_1TfpOMz5_FtHBhNy7iRnPk"
};
module.exports = ___CSS_LOADER_EXPORT___;
